var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { PreorderSettingsInstance } from "../PreorderSettingsInstance";
import { ProductTypePreorderSettingsService } from "./ProductTypePreorderSettingsService";
let ProductInstancePreorderSettingsService = class ProductInstancePreorderSettingsService {
    constructor(productTypePreorderSettingsService) {
        this.productTypePreorderSettingsService = productTypePreorderSettingsService;
        makeImmutable(this);
    }
    preorderSettings(productInstance) {
        const settings = productInstance.parts.parts.map((part) => this.productTypePreorderSettingsService.preorderSettings(part.productType));
        // NOTICE Both parts must have common dates
        return PreorderSettingsInstance.intersection(settings);
    }
};
ProductInstancePreorderSettingsService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ProductTypePreorderSettingsService !== "undefined" && ProductTypePreorderSettingsService) === "function" ? _a : Object])
], ProductInstancePreorderSettingsService);
export { ProductInstancePreorderSettingsService };
